import React from "react"
import Typography from '@mui/material/Typography';
//import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const TextFamChol = () => {

return(
<div>
    
<Typography variant="h6" >
<br />

Familial hypercholesterolemia (FH) is characterized by significantly elevated low-density lipoprotein cholesterol (LDL-C) that leads to atherosclerotic plaque deposition in the coronary arteries and 
proximal aorta at an early age and increases the risk of premature cardiovascular events such as angina and myocardial infarction; stroke occurs more rarely. <br /><br /> 

Xanthomas (cholesterol deposits in tendons) may be visible in the Achilles tendons or tendons of the hands and worsen with age as a result of extremely high cholesterol levels. 
Xanthelasmas (yellowish, waxy deposits) can occur around the eyelids. Individuals with FH may develop corneal arcus (white, gray, or blue opaque ring in the corneal margin as a result of cholesterol deposition) 
at a younger age than those without FH. <br /><br /> 

Individuals with a more severe phenotype, often as a result of biallelic variants, can present with very significant elevations in LDL-C (500 mg/dL), 
# early-onset coronary artery disease (CAD; presenting as early as childhood in some), and calcific aortic valve disease.<br /><br /> 
<br /> <br /> 


<Typography component="span" variant="h5" sx={{fontWeight: '600'}}>Associated Genes: </Typography>
<br /><br />
'LDLR', 'APOB', 'PCSK9', 'TRIB1', 'ZMPSTE24', 'AGPAT2', 'CEL', 'SLCO1B1', 'CETP', 'APOA5', 'CPT2',  'GLIS3', 'ABCA1', 'AKT2', 'RFX6', 'PTF1A', 'LDLRAP1', 'GATA6', 'GCK', 'BSCL2', 'AMPD1', 'COQ2', 'ANGPTL3',
  'GPD1', 'CAVIN1', 'MYLIP', 'HNF4A', 'APOA1', 'APOB', 'GPIHBP1', 'APOC2', 'APOC3', 'APOE', 'INS', 'INSR', 'PDX1', 'KCNJ11', 'LCAT', 'LEP', 'LIPA', 'LIPC', 'LMNA', 'LPA', 'LPL', 'LRP6', 'MEF2A', 'MTTP', 'NEUROD1', 
  'NEUROG3', 'PAX4', 'FOXP3', 'IER3IP1', 'SAR1B', 'INSIG2', 'ABCB1', 'PLIN1', 'PLTP', 'PPARA', 'PPARG', 'SLC25A40', 'PNPLA2', 'PYGM', 'RYR1', 'CIDEC', 'BLK', 'ABCG5', 'LMF1', 'SLC2A2', 'PCDH15', 'HNF1A', 'HNF1B', 
  'WFS1', 'KLF11', 'CAV1', 'CH25H', 'SLC22A8', 'EIF2AK3', 'SCARB1', 'ABCG1', 'TBC1D4'
<br /><br /> 
 
</Typography>

</div>
)
}